
import React from 'react';
import { Control } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from '@/components/ui/checkbox';
import { FormField, FormItem, FormControl, FormLabel } from '@/components/ui/form';

interface FormTermsFieldProps {
  control: Control<any>;
  textColor?: string;
  checkboxClass?: string;
  linkClass?: string;
}

const FormTermsField = ({
  control,
  textColor = "text-gray-900 dark:text-gray-100",
  checkboxClass = "border-gray-300 dark:border-gray-700 data-[state=checked]:bg-synthreo-blue-medium data-[state=checked]:text-white",
  linkClass = "text-synthreo-blue-medium dark:text-blue-400 hover:underline"
}: FormTermsFieldProps) => {
  const navigate = useNavigate();
  
  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/company/terms');
  };
  
  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/company/privacy');
  };

  return (
    <FormField
      control={control}
      name="agreeTerms"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 mt-6">
          <FormControl>
            <Checkbox 
              checked={field.value} 
              onCheckedChange={field.onChange}
              className={checkboxClass}
            />
          </FormControl>
          <FormLabel className={`font-normal ${textColor}`}>
            I agree to the{" "}
            <a href="/company/terms" onClick={handleTermsClick} className={linkClass}>
              Terms of Service
            </a>{" "}
            and{" "}
            <a href="/company/privacy" onClick={handlePrivacyClick} className={linkClass}>
              Privacy Policy
            </a>
          </FormLabel>
        </FormItem>
      )}
    />
  );
};

export default FormTermsField;
